import { useState, useRef } from 'react';
import { Box, Button, Card, CardContent, Typography, Fade, IconButton } from '@mui/material';
import { keyframes } from '@mui/system';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

// スライド内容（画像を全部 /assets/mgs_kun.png に統一）
const slides = [
  { title: '第1章', description: 'これは最初のスライドです。', image: '/assets/mgs_kun.png' },
  { title: '第2章', description: '次の物語が始まります。', image: '/assets/mgs_kun.png' },
  { title: '第3章', description: 'これで完結です！', image: '/assets/mgs_kun.png' },
];

// アニメーション定義
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const zoomIn = keyframes`
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
`;

const PaperTheater: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentSlide > 0) {
      setCurrentSlide((prev) => prev - 1);
    }
  };

  const enterFullscreen = () => {
    if (containerRef.current) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      }
      setIsFullscreen(true);
    }
  };

  const exitFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    setIsFullscreen(false);
  };

  return (
    <Box
      ref={containerRef}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={4}
      sx={{ backgroundColor: '#f0f0f0', p: 2 }}
    >
      <Box position="absolute" top={16} right={16}>
        <IconButton onClick={isFullscreen ? exitFullscreen : enterFullscreen} color="primary">
          {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
      </Box>

      <Fade in timeout={500} key={currentSlide}>
        <Card sx={{ minWidth: 400, p: 3, textAlign: 'center', maxWidth: 800 }}>
          <Box
            component="img"
            src={slides[currentSlide].image}
            alt="Slide"
            sx={{
              width: '100%',
              height: 'auto',
              mb: 2,
              animation: `${zoomIn} 0.8s ease-out, ${float} 4s ease-in-out infinite`,
              animationDelay: '0s, 0.8s',
            }}
          />
          <CardContent>
            <Typography variant="h5" gutterBottom>{slides[currentSlide].title}</Typography>
            <Typography variant="body1">{slides[currentSlide].description}</Typography>
          </CardContent>
        </Card>
      </Fade>

      <Box display="flex" gap={2}>
        <Button variant="outlined" onClick={handleBack} disabled={currentSlide === 0}>
          戻る
        </Button>
        <Button variant="contained" onClick={handleNext} disabled={currentSlide === slides.length - 1}>
          次へ
        </Button>
      </Box>
    </Box>
  );
};

export default PaperTheater;
